import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { RouteNames } from '@nx-ng/constants';
import { ImageUrlService } from '@nx-ng/services/image-url.service';

@Component({
  selector: 'nx-ng-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent {
  constructor(
    private router: Router,
    public imageUrlService: ImageUrlService
  ) {}

  handleReturnHome() {
    this.router.navigate([RouteNames.TICKET_TYPES]);
  }
}
